import { uniq } from "lodash";
import React, { ComponentProps } from "react";

import { useQueriesGetObjectives } from "../../api/operations/objectives";
import {
  getObjectiveAuthorityIdsFromAppState,
  useAppContext,
} from "../../providers/AppContext";

import FacetCheckboxFilter from "./FacetCheckboxFilter";

const FilterObjective = (props: ComponentProps<typeof FacetCheckboxFilter>) => {
  const [appState] = useAppContext();
  const objectiveAuthorityIds = getObjectiveAuthorityIdsFromAppState(appState);

  const standardIds = uniq([
    ...props.options.map((opt) => ({ id: opt.value })),
    ...props.selected.map((id) => ({ id })),
  ]);

  const queries = useQueriesGetObjectives(standardIds);

  const overrides = Object.fromEntries(
    queries.map((query) => [query.data?.id, query.data?.abbreviation]),
  );

  const options = props.options.filter((opt) => {
    if (objectiveAuthorityIds == null || objectiveAuthorityIds.length === 0) {
      return true;
    }
    const query = queries.find((q) => q.data?.id === opt.value);

    if (!query?.data?.authorityId) return true;
    return objectiveAuthorityIds?.includes(query?.data?.authorityId);
  });

  return (
    <FacetCheckboxFilter
      {...props}
      options={options}
      labelOverrides={overrides}
    />
  );
};

export default FilterObjective;
